if (!customElements.get('lp-loyalty-slider')) {
  customElements.define(
    'lp-loyalty-slider',
    class LployaltySlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      init() {
        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

        const desktop = parseFloat(this.dataset.desktop) || 4;
        const tablet = parseFloat(this.dataset.tablet) || 2;
        const mobile = parseFloat(this.dataset.mobile) || 1.2;
        const spaceMobile = parseInt(this.dataset.spaceMobile, 10) || 20;
        const spaceDesktop = parseInt(this.dataset.spaceDesktop, 10) || 20;
        const mobileOffset = 16;

        const swiperOptions = {
          slidesPerView: mobile,
          spaceBetween: spaceMobile,
          slidesOffsetAfter: mobileOffset,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: tablet,
              spaceBetween: spaceMobile,
              slidesOffsetAfter: 0
            },
            1024: {
              slidesPerView: desktop,
              spaceBetween: spaceDesktop,
              slidesOffsetAfter: 0
            }
          }
        };

        if (typeof Swiper !== 'undefined') {
          this.swiper = new Swiper(swiperEl, swiperOptions);
        }
      }
    }
  );
}
